import Vue from 'vue'
import VueRouter from 'vue-router'
import staticRoute from './staticRoute'
import common from '../service/common'
import store from '../store/'
import { isRegExp } from 'util';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: staticRoute
})
import  {adminRouter,rolloutRouter,rollinRouter,stateRouter} from '@/router/routerTable';
router.beforeEach((to, from, next) => {
    //判断用户是否登录
    if(common.getStorage('userInfo')){
        if(store.state.addRouter==0||store.state.addRouter==undefined){
            //组织路由
            const Layout = () => import(/* webpackChunkName: 'index' */ '../page/layout')
            let userInfo=common.getStorage('userInfo');
            let newRouter=[{
                path: '/personal',
                component: () => import(/* webpackChunkName: 'home' */ '../page/personal'),
            }]
            if(userInfo.userRoleList.indexOf('admin')>-1){
                newRouter=newRouter.concat(adminRouter);
            }
            if(userInfo.userRoleList.indexOf('rollout')>-1){
                newRouter=newRouter.concat(rolloutRouter);
            }
            if(userInfo.userRoleList.indexOf('rollin')>-1){
                newRouter=newRouter.concat(rollinRouter);
            }
            if(userInfo.userRoleList.indexOf('statistics')>-1){
                newRouter=newRouter.concat(stateRouter);
            }
            let endRouter=[{
                path: '/home',
                component: Layout,
                children: newRouter
            },
            {
                path:'/404',
                name:'404',
                component: () => import(/* webpackChunkName: 'home' */ '../page/error/index'),
            }];
            router.addRoutes(endRouter);
            store.state.addRouter=1;
            next(to.path)
        }
        else{
            next()
        }
      }else{
        next()
      }
});



export default router


// WEBPACK FOOTER //
// ./src/router/index.js